import { primeHoldingConstants } from "./primeHoldingConstants";

const primeHoldingActions = {};

primeHoldingActions.getPrimeHoldingList = (payload) => ({
    type: primeHoldingConstants.PRIME_HOLDING_SAGA,
    payload
});

export { primeHoldingActions };
